
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[editionOrAuthor]/[authorOrSlug]",
      function () {
        return require("private-next-pages/[editionOrAuthor]/[authorOrSlug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[editionOrAuthor]/[authorOrSlug]"])
      });
    }
  